import { template as template_174a917d32e34217bb709b24278e271a } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { task, waitForProperty } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import { t } from 'ember-intl';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import BsButtonGroup from 'ember-bootstrap/components/bs-button-group';
import BsTooltip from 'eflex/components/bs-tooltip';
import { fn } from '@ember/helper';
import { not } from 'ember-truth-helpers';
export default class InputsLockObject extends Component {
    @service
    imageEditor;
    onDidInsert = task(waitFor(async ()=>{
        await waitForProperty(this.imageEditor, 'canvas');
        this.#checkAndSetLocked();
        this.imageEditor.on('selection:created', this.#checkAndSetLocked).on('selection:updated', this.#checkAndSetLocked);
    }));
    toggleLock = task(waitFor(async (locked)=>{
        const objects = this.imageEditor.canvas.getActiveObjects();
        if (objects == null) {
            return;
        }
        for (const obj of objects){
            obj.lockMovementX = locked;
            obj.lockMovementY = locked;
            obj.lockRotation = locked;
            obj.lockScalingX = locked;
            obj.lockScalingY = locked;
            obj.lockSkewingX = locked;
            obj.lockSkewingY = locked;
        }
        await this.imageEditor.updateHistory.perform();
        this.args.onChange(locked);
    }));
    #checkAndSetLocked = ()=>{
        const obj = this.imageEditor.canvas.getActiveObject();
        if (obj == null) {
            return;
        }
        const locked = obj.lockMovementX && obj.lockMovementY && obj.lockRotation && obj.lockScalingX && obj.lockScalingY && obj.lockSkewingX && obj.lockSkewingY;
        this.args.onChange(locked);
    };
    willDestroy() {
        super.willDestroy(...arguments);
        this.imageEditor.off('selection:created', this.#checkAndSetLocked).off('selection:updated', this.#checkAndSetLocked);
    }
    static{
        template_174a917d32e34217bb709b24278e271a(`
    <BsButtonGroup
      class="
        wie-lock-object-toggle d-flex align-items-center
        {{if @locked "app-unlock" "app-lock"}}
        {{if @disabled "pe-none opacity-25"}}
      "
      @type="radio"
      @value={{@locked}}

      {{didInsert this.onDidInsert.perform}}
    ...attributes
    as |bg|>
      <bg.button
        @value={{true}}
        @type="peripheral d-flex border-0 {{if @locked "text-primary"}}"
        @onClick={{fn this.toggleLock.perform (not @locked)}}
      >
        <FaIcon @icon={{if @locked "lock" "lock-open"}} @prefix="fas" class="fa-fw" />
        <BsTooltip @title={{t "imageEditor.lock"}} @delayShow={{600}} />
      </bg.button>
    </BsButtonGroup>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
